import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";

import Header from "../inc/Header";
import solidchuri32_540gm from "../images/32.540gm Solid churi.jpg";
import solidchuri32_540gm_100gm from "../images/34.100gm.jpg";
import solidchuri37_280gm from "../images/37.280gm.jpg";
import churi38_270gm from "../images/38.270gm.jpg"

import sc12gm from "../images/12gm new.jpg";

import solidchuri45_540 from "../images/45.540gm.jpg";

import solid31_400gm from "../images/31.400gm.jpg";
import solidchuri from "../images/solid churi.jpg";

import solidchuri11gm from "../images/11gm.jpg";


import solidchuri12gm from "../images/12gm.jpg";



import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function Solidchuripage() {
    return (
        <div>

            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Solid Churi</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
<div className='solidchur'>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={solidchuri32_540gm} className="card-img-top" alt="solidchuri32_540gm" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi </h5>
                                                <p className="card-text">Weight: 32.540gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={solidchuri32_540gm_100gm} className="card-img-top" alt="solidchuri32_540gm_100gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi</h5>
                                                <p className="card-text">Weight: 34.100gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={solidchuri37_280gm} className="card-img-top" alt="solidchuri37_280gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Solid Churi </h5>
                                                <p className="card-text">Weight: 37.280gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={churi38_270gm} className="card-img-top" alt="churi38_270gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Solid Churi                                   </h5>
                                                <p className="card-text">Weight: 38.270gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                               
                                    <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={solidchuri45_540} className="card-img-top" alt="solidchuri45_540"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi </h5>
                                                <p className="card-text">Weight: 45.540gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={solid31_400gm} className="card-img-top" alt="solid31_400gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi</h5>
                                                <p className="card-text">Weight: 31.400gm</p>
                                                <p className="card-text mb-2">ID No..</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={solidchuri} className="card-img-top" alt="solidchuri"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Solid Churi</h5>
                                                <p className="card-text">Weight: 24.600gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={solidchuri11gm} className="card-img-top" alt="solidchuri11gm"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Solid Churi</h5>
                                                <p className="card-text">Weight: 11.00gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={sc12gm} className="card-img-top" alt="sc12gm" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi </h5>
                                                <p className="card-text ">Weight: 12.00gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={solidchuri12gm} className="card-img-top" alt="solidchuri12gm" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Solid Churi</h5>
                                            <p className="card-text">Weight: 12.00gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9434168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>




        
            </div>
            <br />

            <br />
        </div>
    )
}

export default Solidchuripage